<template>
  <v-layout
    class="patient-page"
    column
    style="background-color:#525659"
  >
    <v-toolbar color="white" flat>
      <v-toolbar-title>{{this.$route.params.id}}</v-toolbar-title>
    <v-spacer></v-spacer>
    <v-btn @click="patientSearch">Patient Search</v-btn>
    </v-toolbar>

    <v-divider></v-divider>
    <iframe frameBorder="0" style="height: 100%; width: 100%;" :src="fileURL"/>
    <!-- <patient-assignment/> -->
    <patient-search-dialog @valuesEmit="confirmAssignment" ref="patientSearch"/>
    <confirm-assignment-dialog @confirmedAssignmentEmit="assignDocumentToPatient" ref="confirmAssignment"/>
  </v-layout>
</template>


<script>
import { mapState, mapActions } from 'vuex'
import bus from '@/core/helpers/bus'
import AdvancedPatientSearchAdmin from '@/components/dialogs/AdvancedPatientSearchAdmin'
import PatientSearchDialog from '@/components/dialogs/PatientSearchDialog'
import FileDialog from '@/components/dialogs/FileDialog'
import PatientAssignment from '@/components/PatientAssignment'
import ConfirmAssignmentDialog from '@/components/dialogs/ConfirmAssignmentDialog'

export default {
  name: 'AdminDocumentsPage',
  components: {
    AdvancedPatientSearchAdmin,
    PatientSearchDialog,
    FileDialog,
    PatientAssignment,
    ConfirmAssignmentDialog
  },
  data() {
    return {
      // Document information
      fileURL: null,
      headers: {},
      documentId: null,

      // Patient search
      patientID: null,
      patientInfo: null,
      requestID: null,
      providerID: null,
      providerInfo: null,
      orginalProviderInfo: null,
      orginalRequestInfo: null,
      patientRequestChanges: false,
      patientLabel: 'Patient',

      // Date of care
      dateOfCareInput: null,
      dateOfCareMask: '##/##/####',
      dateOfCareHint: 'mm/dd/yyyy',
      dateOfCareLabel: 'Date of Care',

      // Document Type
      typeInput: { text: 'UNKNOWN', value: 'UNKNOWN' },
      typeLabel: 'Document Type',
      recordTypes: [],

      // Document Description
      description: null,
      descriptionLabel: 'Document Description',

      // Loading statuses
      patientLoading: true,
      providerLoading: true,
      documentLoading: true,

      // Iframe
      iframeSource: null
    }
  },
  methods: {
    ...mapActions('admin', [
      'getFile',
      'setFileInfo',
      'getRecordTypes',
      'setStatus',
      'getDocumentProvider',
      'getPatients',
      'getPatient',
      'openFile',
      'viewFile'
    ]),
    ...mapActions('provider', ['getProviderIDFromNPI', 'search']),
    submitDocumentChanges() {
      let vm = this
      let file = {}

      if (vm.providerID) {
        file.renderingProvider = vm.providerID
      }
      if (vm.patientID) {
        file.patient = this.patientID
      }
      if (vm.dateOfCareInput) {
        file.encounterDate = vm.unixEncounterDate(vm.dateOfCareInput)
      }
      if (vm.typeInput) {
        if (vm.typeInput.value) {
          file.recordType = vm.typeInput.value
        } else {
          file.recordType = vm.typeInput
        }
      }
      if (vm.description) {
        file.description = vm.description
      }
      if (vm.requestID) {
        file.request = vm.requestID
        vm.setRequestToComplete(vm.requestID)
      }

      vm.setFileInfo({ file, id: vm.documentId }).then(() => {
        vm.toast('success', 'Document successfully updated')
      })
    },
    patientSearch() {
      this.$refs.patientSearch.open()
    },
    archiveFile() {
      let vm = this
      let file = {}
      file.archived = true

      vm.setFileInfo({ file, id: vm.documentId }).then(() => {
        vm.toast('success', 'Document archived')
      })
    },
    // Formatting the encounter date, format example: '2012.08.10 (YYYY-MM-DD)'
    unixEncounterDate(date) {
      if (date !== '') {
        const formatDate =
          date.slice(0, 2) + '/' + date.slice(2, 4) + '/' + date.slice(4, 8)
        console.log(new Date(formatDate).getTime() / 1000)
        console.log(new Date(formatDate).getTime() / 1000)
        return new Date(formatDate).getTime() / 1000
      }
    },
    toast(type, text) {
      bus.$emit('toast', { type, text })
    },
    showPatientSearch() {
      this.$refs.patientSearchDialog.open({})
    },
    openFile2(file) {
      this.$refs.fileDialog.open({
        file
      })
    },
    convertDate(timestamp) {
      let d = new Date(timestamp * 1000)

      let month = d.getMonth()
      let day = d.getDate()
      let year = d.getFullYear()

      let monthStringExtra = ''
      let dayStringExtra = ''

      if (month < 10) {
        monthStringExtra = '0'
      }
      if (day < 10) {
        dayStringExtra = '0'
      }

      let date =
        monthStringExtra +
        (month + 1).toString() +
        dayStringExtra +
        day.toString() +
        year
      return date
    },
    // TODO: Deprecated
    openSelectedFileDialog(fileBundle) {
      console.log(fileBundle)
      let file = fileBundle
      this.openFile(file)
    },
    loadIframe(fileBundle) {
      console.log(fileBundle)
      // get the url of the files to be displayed
      let url = null
      switch (fileBundle.mimetype) {
        case 'application/dicom+zip':
          let imgs = fileBundle
          let q = []
          for (let i = 0; i < imgs.length; i++) {
            let img = imgs[i]
            q.push(img._id, img.dicomNumFiles, img.accessToken)
          }
          if (!this.isMobile) {
            url =
              'https://onechart-clinical-viewer.firebaseapp.com/' +
              '?study=' +
              q.join(',')
          } else {
            url = process.env.DICOM_VIEWER_URL + '?study=' + q.join(',')
          }
          break
        case 'application/pdf':
          url =
            fileBundle.downloadURL +
            '?alt=media&token=' +
            fileBundle.accessToken
          let fileUrl =
            process.env.PDF_VIEWER_URL + '?file=' + encodeURIComponent(url)
          url = fileUrl
          break
      }
      this.iframeSource = url
    },
    selectPatientAndRequest(vals) {
      this.patientID = vals.patient
      if (vals.request) {
        this.requestID = vals.request
        this.fillOutDocInfoFromRequest(vals.request)
        this.providerInfo = vals.provider
        this.providerID = vals.provider.id
      }
      this.patientRequestChanges = true
    },
    fillOutDocInfoFromRequest() {},
    setRequestToComplete(requestID) {
      this.setStatus({
        id: requestID,
        status: {
          status: 'COMPLETED'
        }
      })
    },
    cancel() {
      if (this.orginalProviderInfo) {
        this.providerID = this.orginalProviderInfo.id
      } else this.providerID = null
      this.providerInfo = this.orginalProviderInfo

      if (this.orginalRequestInfo) {
        this.requestID = this.orginalRequestInfo
      } else {
        this.requestID = null
      }

      this.patientRequestChanges = false
    },
    tieDocumentAndRequest() {
      if (this.requestID) {
        let file = {
          request: this.requestID
        }

        this.setFileInfo({ file, id: this.documentId }).then(() => {
          this.toast('success', 'Request and document successfully tied')
        })
      }
    },
    confirmAssignment(payload) {
      this.$refs.confirmAssignment.open({
        payload: payload
      })
    },
    assignDocumentToPatient(payload) {
      let file = {}
      if (payload.provider) {
        file.renderingProvider = payload.provider
      }
      if (payload.request) {
        file.request = payload.request
        this.setRequestToComplete(payload.request)
      }
      if (payload.patient) {
        file.patient = payload.patient
        this.setFileInfo({ file, id: this.documentId }).then(() => {
          this.toast('success', 'Document Filed to Chart')
        })
      } else {
        this.toast('error', 'No Patient Selected')
      }
    }
  },
  computed: {
    ...mapState('admin', ['file', 'documentProvider']),
    ...mapState('provider', ['searchResults']),
    providerDisplay() {
      if (!this.providerID) {
        return null
      } else if (this.providerInfo) {
        if (this.providerInfo.firstName && this.providerInfo.lastName) {
          return this.providerInfo.firstName + ' ' + this.providerInfo.lastName
        } else if (this.providerInfo.organizationName) {
          return this.providerInfo.organizationName
        } else {
          return this.providerID
        }
      }
    },
    patientDisplay() {
      if (!this.patientID) {
        this.patientLoading = false
        return null
      } else if (!this.patientInfo || this.patientInfo.id !== this.patientID) {
        this.patientLoading = true
        this.getPatient({ id: this.patientID }).then(patient => {
          this.patientInfo = patient
          this.patientLoading = false
          return this.patientInfo.firstName + ' ' + this.patientInfo.lastName
        })
      } else {
        this.patientLoading = false
        return this.patientInfo.firstName + ' ' + this.patientInfo.lastName
      }
    }
  },
  mounted() {
    this.viewFile(this.$route.params.id).then((data) => {
      console.log('view file is back')
      console.log(data)
      this.fileURL = data
    })
  },
  created() {
    let vm = this

    this.getRecordTypes().then(data => {
      let tempRT = []
      for (let d in data.data) {
        tempRT.push({ text: data.data[d], value: data.data[d] })
      }
      this.recordTypes = tempRT
    })

    vm.documentId = vm.$route.params.id
    this.getFile(vm.documentId).then(() => {
      let file = vm.file[0]
      // openSelectedFileDialog(file)
      if (vm.file[0]) {
        vm.loadIframe(vm.file[0])
      }

      if (file.patient && file.patient.id) {
        vm.patientID = file.patient.id
      } else {
        vm.patientLoading = false
      }

      if (file.renderingProvider && file.renderingProvider.id) {
        vm.providerID = file.renderingProvider.id
        vm.getDocumentProvider({ id: vm.providerID }).then(providerInfo => {
          vm.orginalProviderInfo = providerInfo
          vm.providerInfo = providerInfo
          vm.providerLoading = false
        })
      } else {
        vm.providerLoading = false
      }
      if (file.encounterDate) {
        vm.dateOfCareInput = vm.convertDate(file.encounterDate)
      }
      if (file.recordType) {
        let tempType = { text: '', value: '' }
        tempType.text = file.recordType
        tempType.value = file.recordType

        vm.typeInput = tempType
      }
      if (file.request && file.request.id) {
        vm.orginalRequestInfo = file.request.id
        vm.requestID = file.request.id
      }
      if (file.description) {
        vm.description = file.description
      }
    })

    this.documentLoading = false
  }
}
</script>

<style lang="scss" scoped>
.admin-title {
  font-size: 18px;
  font-weight: 400;
  color: black;
  margin-right: 10px;
  transition: 0.4s;
  border-bottom: 2px solid transparent;
}

.admin-title-bold {
  font-size: 18px;
  font-weight: 600;
  color: black;
  margin-right: 10px;
  transition: 0.4s;
  border-bottom: 2px solid transparent;
}

.admin-content {
  font-size: 16px;
  font-weight: 500;
  color: black;
  padding-top: 15px;
}

.admin-content-bold {
  font-size: 16px;
  font-weight: 600;
  color: black;
  padding-top: 15px;
}

.admin-content-helper {
  font-size: 12px;
  font-weight: 400;
  color: black;
  padding-top: 5px;
}

.border {
  border: 1px solid #e6e6e8;
}

.centered {
  position: fixed;
  top: 35%;
  left: 50%;
}
</style>





// WEBPACK FOOTER //
// src/pages/admin/AdminDocumentPage.vue